import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddressPicker = _resolveComponent("AddressPicker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_custom_table = _resolveComponent("custom-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_create_regional_dialog = _resolveComponent("create-regional-dialog")!
  const _component_operation_drawer = _resolveComponent("operation-drawer")!
  const _component_app_page = _resolveComponent("app-page")!

  return (_openBlock(), _createBlock(_component_app_page, { class: "regional-list" }, {
    fheader: _withCtx(() => [
      _createVNode(_component_el_form, {
        size: "default",
        ref: "queryForm",
        "label-width": "100px",
        model: _ctx.params,
        onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.handleSearch()), ["enter"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "所属地区",
            prop: "customerName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AddressPicker, {
                gutter: 0,
                showType: ['province', 'city'],
                province: _ctx.addressList?.[0],
                city: _ctx.addressList?.[1],
                onChange: _ctx.handleChangeAddress
              }, null, 8, ["province", "city", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            "label-width": "0",
            class: "margin-left-20"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "default",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSearch())),
                onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.handleSearch()), ["enter"]))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 查询 ")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                size: "default",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleReset()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 重置 ")
                ]),
                _: 1
              }),
              (_ctx.$has(_ctx.permissionConfig.CREATE))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    size: "default",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleRegionalSetting()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 创建区域 ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    main: _withCtx(({ height }) => [
      (_openBlock(), _createBlock(_component_custom_table, {
        border: "",
        height: height,
        key: height,
        data: _ctx.tableData,
        columns: _ctx.renderColumns(_ctx.handleRegionalSetting, _ctx.handleOperation,
                                _ctx.permissionConfig.EDIT, _ctx.permissionConfig.VIEW_LOG)
      }, null, 8, ["height", "data", "columns"]))
    ]),
    ffooter: _withCtx(() => [
      _createVNode(_component_el_row, {
        style: {"width":"100%"},
        type: "flex",
        justify: "end"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_pagination, {
            total: _ctx.tableTotal,
            "current-page": _ctx.params.pageNum,
            "page-size": _ctx.params.pageSize,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange
          }, null, 8, ["total", "current-page", "page-size", "onSizeChange", "onCurrentChange"])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_create_regional_dialog, {
        modelValue: _ctx.regional.visible,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.regional.visible) = $event)),
        onHandelSuccess: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleSearch())),
        regionId: _ctx.regional.regionId
      }, null, 8, ["modelValue", "regionId"]),
      _createVNode(_component_operation_drawer, {
        modelValue: _ctx.operation.visible,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.operation.visible) = $event)),
        request: _ctx.regionAreaLogApi,
        requestParams: _ctx.operation.regionId,
        config: _ctx.config
      }, null, 8, ["modelValue", "request", "requestParams", "config"])
    ]),
    _: 1
  }))
}